import ClampLines from 'react-clamp-lines';
import PropTypes from 'prop-types';
import React from 'react';

import {
  Container,
  Item,
  Label,
  Number,
} from './styles';

const ListChart = (props) => (
  <Container>
    {props.data.map(({ id, number, text }) => (
      <Item key={id}>
        <Number color={props.color}>
          {number}
        </Number>

        <Label>
          <ClampLines
            text={text}
            lines={1}
            ellipsis="..."
            buttons={false}
          />
        </Label>
      </Item>
    ))}
  </Container>
);

ListChart.propTypes = {
  color: PropTypes.string,
  data: PropTypes.array,
};

ListChart.defaultProps = {
  color: '',
  data: [],
};

export default ListChart;
